import * as React from "react";
import AnnotationGeometry from "./AnnotationGeometry";
import { useAnnotationActions } from "context/";

const AnnotationCircle = ({ annotation }) => {
  const { addCircle } = useAnnotationActions();

  return <AnnotationGeometry annotation={annotation} addGeometry={addCircle} />;
};

export default AnnotationCircle;
